import reducer from "./reducer";
export { default as SocialBlacklist } from "./components";
export { default as socialBlacklistReducerName } from "./constants";
export default reducer;
